/*eslint-disable*/
import React, { useEffect, useState } from "react";
import { useNetwork } from "../../components/NetworkProvider";
import FastAPIClient from "../../client";
import config from "../../config";
const client = new FastAPIClient(config);
import {
    blankExpandedLevels,
    blankFilters,
} from "../../utils/Products/functions";
import { level_one_mapping } from "../../utils/Products/mapping";
import { ProductType, ProductSubCategories } from "../../types/product.t";
import { useIntl } from "react-intl";
import BackButton from "../Buttons/BackButton";
import { HiChevronDown } from "react-icons/hi2";
import { toTitleCase } from "../../utils/functions";
import { ExpandedLevels } from "../../utils/Products/functions";
import { Button } from "@mui/material";

import FiltersSkeleton from "../Skeletons/FiltersSkeleton";
import Filters from ".";
// subcategory
//format
// brand
// consigne
// country

interface ProductFiltersProps {
    category: string;
    setSelectedCategory: React.Dispatch<React.SetStateAction<string | null>>;
    expandedLevels: ExpandedLevels;
    setExpandedLevels: React.Dispatch<React.SetStateAction<ExpandedLevels>>;
    shownProducts: ProductType[];
    setShownProducts: React.Dispatch<React.SetStateAction<ProductType[]>>;
    selectedFilters: Record<string, string[]>;
    setSelectedFilters: React.Dispatch<
        React.SetStateAction<Record<string, string[]>>
    >;
    subCategories: ProductSubCategories;
    setSubCategories: React.Dispatch<
        React.SetStateAction<ProductSubCategories>
    >;
    allProducts: ProductType[];
    mobileFilterOpen: boolean;
    mobileFilters: Record<string, string[]>;
    setMobileFilters: React.Dispatch<
        React.SetStateAction<Record<string, string[]>>
    >;
    setIsFilterOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const ProductFilters: React.FC<ProductFiltersProps> = ({
    category,
    setSelectedCategory,
    expandedLevels,
    setExpandedLevels,
    selectedFilters,
    setSelectedFilters,
    subCategories,
    setSubCategories,
    allProducts,
    mobileFilterOpen,
    mobileFilters,
    setMobileFilters,
    setIsFilterOpen,
}) => {
    const intl = useIntl();
    const { isOnline } = useNetwork();

    const [initialSubCategories, setInitialSubCategories] =
        useState<ProductSubCategories | null>(null);

    const getProductSubCategories = async (
        category: string,
        subcategories: any
    ) => {
        client
            .getProductSubCategories({ category }, { subcategories })
            .then((data: ProductSubCategories) => {
                // Sort each category's values alphabetically
                const sortedData = Object.entries(data).reduce(
                    (acc, [key, values]) => {
                        if (Array.isArray(values)) {
                            acc[key] = [...values].sort((a, b) => {
                                const labelA = String(a).toLowerCase();
                                const labelB = String(b).toLowerCase();
                                return labelA.localeCompare(labelB);
                            });
                        } else {
                            acc[key] = values;
                        }
                        return acc;
                    },
                    {} as ProductSubCategories
                );

                setSubCategories(sortedData);
                setInitialSubCategories(sortedData);
            });
    };

    const getProductSubCategoriesOffline = (newObj: any) => {
        if (allProducts.length === 0) return; // wait until products are fetched offline
        const resultsObj: Partial<ProductSubCategories> = {};

        Object.keys(newObj).forEach((key) => {
            const values = allProducts
                .filter((pr) => pr.product_level_1 === category)
                .filter(
                    (pr) => pr && key in pr && pr[key] != null && pr[key] !== ""
                )
                .map((pr) => pr[key]);
            const uniqueValues = [...new Set(values)].sort((a, b) => {
                const labelA = String(a).toLowerCase();
                const labelB = String(b).toLowerCase();
                return labelA.localeCompare(labelB);
            });
            resultsObj[key as keyof ProductSubCategories] = uniqueValues;
        });

        setSubCategories(resultsObj as ProductSubCategories);
        setInitialSubCategories(resultsObj as ProductSubCategories);
    };

    useEffect(() => {
        const newObj = {};
        const generalFilters = [
            "container_format",
            "manufacturer_brand",
            "deposit",
            "country",
        ];
        level_one_mapping[category].forEach((sub) => (newObj[sub] = []));
        generalFilters.forEach((filter) => (newObj[filter] = []));
        if (isOnline) {
            getProductSubCategories(category, newObj);
        } else {
            getProductSubCategoriesOffline(newObj);
        }
    }, [category, allProducts]);

    const reset = () => {
        setSelectedFilters(blankFilters);
        setMobileFilters(blankFilters);
        setExpandedLevels(blankExpandedLevels);
        setSubCategories(initialSubCategories);
    };

    const resetCategory = () => {
        setSelectedCategory(null);
        setSelectedFilters(blankFilters);
        setMobileFilters(blankFilters);
        setExpandedLevels(blankExpandedLevels);
        setSubCategories(null);
        setInitialSubCategories(null);
    };

    return (
        <div className="flex flex-col h-full w-full relative">
            {/* Header */}
            <div className="px-4 w-full">
                <div
                    className="mb-2 w-full flex cursor-pointer gap-3 hover:text-gray-700 md:text-sm items-center"
                    onClick={resetCategory}
                >
                    <BackButton handleGoBack={resetCategory}>
                        {intl.formatMessage({ id: "filters.other_category" })}
                    </BackButton>
                </div>
            </div>

            {/* Scrollable Content */}
            <div className="flex-1 overflow-y-auto px-4 pb-4 no-scrollbar">
                <Filters
                    subCategories={subCategories}
                    expandedLevels={expandedLevels}
                    setExpandedLevels={setExpandedLevels}
                    selectedFilters={selectedFilters}
                    setSelectedFilters={setSelectedFilters}
                    reset={reset}
                    mobileFilterOpen={mobileFilterOpen}
                    mobileFilters={mobileFilters}
                    setMobileFilters={setMobileFilters}
                    setIsFilterOpen={setIsFilterOpen}
                />
            </div>
        </div>
    );
};

export default ProductFilters;
